import { roles as correspondentRoles } from '@constants/correspondent';

interface CurrentUserLike {
  role_description?: unknown;
  role_name?: unknown;
}

const isProtectedRole = (role: string): boolean =>
  role === correspondentRoles?.bankAdmin || role === correspondentRoles?.correspondentAdmin;

export const SUPERVISOR_BANK_CREATABLE_ROLES = [
  correspondentRoles?.correspondentConsultant,
  correspondentRoles?.correspondentSupervisor,
  correspondentRoles?.cashierCorporate,
  correspondentRoles?.rotativeSupervisor,
].filter((role): role is string => typeof role === 'string');

export const CORRESPONDENT_ADMIN_CREATABLE_ROLES = [
  correspondentRoles?.correspondentAdmin,
  correspondentRoles?.correspondentConsultant,
  correspondentRoles?.correspondentSupervisor,
  correspondentRoles?.cashierCorporate,
  correspondentRoles?.rotativeSupervisor,
].filter((role): role is string => typeof role === 'string');

export const getCurrentUserRole = (user?: CurrentUserLike | null): string => {
  const role = user?.role_description ?? user?.role_name;
  return typeof role === 'string' ? role : '';
};

export const getCreatableUserRoles = (currentUserRole: string): readonly string[] | null => {
  if (currentUserRole === correspondentRoles?.supervisorBank) {
    return SUPERVISOR_BANK_CREATABLE_ROLES;
  }
  if (currentUserRole === correspondentRoles?.correspondentAdmin) {
    return CORRESPONDENT_ADMIN_CREATABLE_ROLES;
  }
  return null;
};

export const canManageUserRole = (currentUserRole: string, targetRole?: string | null): boolean => {
  if (!targetRole) return true;
  if (isProtectedRole(targetRole)) return false;
  return targetRole !== currentUserRole;
};
